$(() => {
  $.fn.accessCodeEntry = function plugin(options) {
    let xhr = null;
    const defaults = {
      i18n: {
        success: 'Success!',
      },
      eventUri: null,
    };

    /**
     *
     * @param data
     * @param event
     */
    const submit = (data, event) => {
      const code = data.elements.$input.val();
      const subEventId = data.elements.$container.data('sub-event-id');

      data.elements.$feedback.text('').addClass('hidden');

      if (!data.elements.$form[0].checkValidity()) {
        return;
      }

      event.preventDefault();

      xhr = $.ajax({
        url: `${data.settings.eventUri}/validate-access-code`,
        type: 'post',
        data: {
          code,
          sub_event_id: subEventId,
        },
      })
        .always(() => {
          xhr = null;
          data.elements.$feedback.removeClass('hidden');
          data.elements.$input.focus();
        })
        .done((response) => {
          data.elements.$feedback.text(data.settings.i18n.success);
          window.location.href = response;
        })
        .fail((response) => {
          data.elements.$form.trigger('raceRoster.preventDoubleSubmission.reEnable');

          if (response.status) {
            data.elements.$feedback.text(response.responseText);
          }
        });
    };

    /**
     *
     * @param data
     */
    const activate = (data) => {
      data.elements.$activate.addClass('hidden').attr('aria-expanded', true);
      data.elements.$form.removeClass('hidden');
      data.elements.$input.focus();
    };

    /**
     *
     * @param data
     */
    const cancel = (data) => {
      if (xhr) {
        xhr.abort();
      }

      data.elements.$form.addClass('hidden');
      data.elements.$activate.removeClass('hidden').attr('aria-expanded', false).focus();
    };

    /**
     *
     * @param data
     * @param event
     */
    const keyup = (data, event) => {
      if (event.keyCode === 27) {
        cancel(data);
        event.stopPropagation();
      }
    };

    /**
     *
     * @param index
     * @param element
     */
    const initialize = (index, element) => {
      const $element = $(element);
      const data = {
        settings: $.extend(true, {}, defaults, options),
        elements: {
          $container: $element,
          $activate: $element.find('.js-access-code-entry-activate'),
          $form: $element.find('.js-access-code-entry-form'),
          $input: $element.find('.js-access-code-entry-input'),
          $feedback: $element.find('.js-access-code-entry-feedback'),
        },
      };

      data.elements.$activate.on('click', () => activate(data));
      data.elements.$form.on('reset', () => cancel(data));
      data.elements.$form.on('submit', (event) => submit(data, event));
      data.elements.$form.on('keyup', (event) => keyup(data, event));
    };

    return this.each(initialize);
  };
});
